export default __webpack_public_path__ + "static/media/almalinux.69cf2b95.svg";